var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (parseInt(_vm.discount, 10) > 0)?_c('div',{staticClass:"calculator__flag",class:{ border: _vm.border, fill: !_vm.border },style:({
    color: _vm.color,
    borderColor: _vm.border ? _vm.fill : 'transparent',
    background: _vm.border ? 'transparent' : _vm.fill,
  })},[_vm._v("\n  -"+_vm._s(_vm.discount)+"%\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }